import React, { useState } from "react";
import styled from "styled-components";
import useProductName from "brand-customization/useProductName";
import { ModalSubmit, Spinner } from "components/common";
import { Alert, Button, FormGroup, Modal, Input } from "components/bootstrap";
import { adjustFormat } from "util/DateTime";
const formatDatetime = (datetime) => adjustFormat(datetime, "date");
const StyledDl = styled.dl`
  margin-bottom: 0;
`;
const ImportLicenseModal = ({
  verifiedLicense = void 0,
  errorMessage = void 0,
  verifyLicense,
  saveLicense
}) => {
  const productName = useProductName();
  const [showModal, setShowModal] = useState(false);
  const [token, setToken] = useState(void 0);
  const [showImportLoading, setShowImportLoading] = useState(false);
  const openModal = () => {
    setShowModal(true);
  };
  const resetModal = () => {
    setShowImportLoading(false);
    setToken(void 0);
    setShowModal(false);
  };
  const save = () => {
    if (errorMessage) return;
    setShowImportLoading(true);
    saveLicense(token, resetModal);
  };
  const updateLicenseInformation = (event) => {
    const newToken = event.target.value;
    setToken(newToken);
    if (newToken) {
      verifyLicense(newToken);
    }
  };
  const licenseAudience = (license) => {
    if (license.audience.name === "" && license.audience.email === "") {
      return license.audience.company;
    }
    return `${license.audience.company}:${license.audience.name && ` ${license.audience.name}`}${license.audience.email && ` <${license.audience.email}>`}`;
  };
  const disableSubmit = token === void 0 || token === "" || !verifiedLicense || !!errorMessage;
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Button, { onClick: openModal, bsStyle: "primary" }, "Import new license"), showModal && /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide: resetModal }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Import new ", productName, " license")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormGroup, { id: "licenseTextarea" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "license-token",
      name: "description",
      label: "License",
      type: "textarea",
      value: token,
      onChange: updateLicenseInformation,
      rows: 5,
      disabled: showImportLoading,
      required: true
    }
  )), !token ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "Please add the license key for your cluster in the text field above.") : /* @__PURE__ */ React.createElement(
    Alert,
    {
      bsStyle: errorMessage ? "danger" : "success",
      title: `${errorMessage ? "Invalid" : "Valid"} license`
    },
    errorMessage && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, "Reason"), ": ", errorMessage),
    verifiedLicense && /* @__PURE__ */ React.createElement(React.Fragment, null, !disableSubmit && /* @__PURE__ */ React.createElement("p", null, productName, " will reload after importing the license to make sure the changes are applied correctly."), /* @__PURE__ */ React.createElement(StyledDl, null, /* @__PURE__ */ React.createElement("dt", null, "Licensed to"), /* @__PURE__ */ React.createElement("dd", null, licenseAudience(verifiedLicense)), /* @__PURE__ */ React.createElement("dt", null, "Valid from"), /* @__PURE__ */ React.createElement("dd", null, formatDatetime(verifiedLicense.not_before_date)), /* @__PURE__ */ React.createElement("dt", null, "Valid until"), /* @__PURE__ */ React.createElement("dd", null, formatDatetime(verifiedLicense.expiration_date))))
  ))), /* @__PURE__ */ React.createElement(Modal.Footer, null, showImportLoading ? /* @__PURE__ */ React.createElement(Spinner, { text: "Importing license" }) : /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel: resetModal,
      onSubmit: save,
      submitButtonType: "button",
      disabledSubmit: disableSubmit,
      submitButtonText: "Import License"
    }
  ))));
};
export default ImportLicenseModal;
